module.exports = __webpack_public_path__ + "img/maintop.0d763e5.png";